export default "__VITE_ASSET__wZmsu941__"